import { createPlanningObjectsReducer } from "../planningObjects"

export default createPlanningObjectsReducer("orderPositions")
